export const b2bUrl = "/b2b";
export const oeUrl = "/parts";
